<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Edit Parent" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col class="pa-0" cols="12" sm="6">
            <v-col cols="12">
              <div class="font-weight-medium">Father</div>
            </v-col>
            <v-col cols="12">
              <v-text-field
                :error-messages="fatherNameErrors"
                v-model="customer.fatherName"
                :background-color="`${
                  customer.fatherName ? false : $style.inputBox.mandatory
                }`"
                label="Father Name"
                @change="customer.fatherName = properCase(customer.fatherName)"
                :hide-details="fatherNameErrors.length === 0"
                outlined
                @focus="$event.target.select()"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                hide-details
                dense
                @focus="$event.target.select()"
                v-model="customer.fatherPhoneNumber"
                label="Phone Number"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                outlined
                hide-details
                dense
                v-model="customer.fatherEmailAddress"
                label="Email Address"
              ></v-text-field>
            </v-col>
          </v-col>
          <v-col class="pa-0" cols="12" sm="6">
            <v-col cols="12">
              <div class="font-weight-medium">Mother</div>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="customer.motherName"
                label="Name"
                @change="customer.motherName = properCase(customer.motherName)"
                outlined
                hide-details=""
                @focus="$event.target.select()"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                hide-details
                dense
                @focus="$event.target.select()"
                v-model="customer.motherPhoneNumber"
                label="Phone Number"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                outlined
                hide-details
                dense
                v-model="customer.motherEmailAddress"
                label="Email Address"
              ></v-text-field>
            </v-col>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12">
            <v-text-field
              outlined
              hide-details
              dense
              v-model="customer.address"
              label="Address"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-text-field
              outlined
              hide-details
              dense
              @change="customer.city = properCase(customer.city)"
              v-model="customer.city"
              label="City"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              outlined
              dense
              hide-details
              v-model="customer.state"
              label="State"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              outlined
              hide-details
              dense
              v-model="customer.zip"
              label="Zip Code"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <div class="font-weight-medium">Emergency Contact</div>
          </v-col>

          <v-col cols="6" xs="12" sm="12">
            <v-text-field
              v-model="customer.emergencyContactName"
              label="Name"
              @change="
                customer.emergencyContactName = properCase(
                  customer.emergencyContactName
                )
              "
              hide-details
              outlined
              @focus="$event.target.select()"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              outlined
              hide-details
              dense
              @focus="$event.target.select()"
              v-model="customer.emergencyContactNumber"
              label="Phone Number"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-text-field
              outlined
              hide-details
              dense
              v-model="customer.emergencyContactEmailAddress"
              label="Email Address"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12">
            <v-textarea
              outlined
              hide-details
              dense
              auto-grow
              v-model="customer.note"
              :label="$t('labels.note')"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <span class="mr-2">Balance</span>
        <toggle-button
          :width="60"
          :labels="{ checked: 'Show', unchecked: 'Hide' }"
          v-model="customer.showBalance"
          :value="customer.showBalance"
          :sync="true"
        >
        </toggle-button>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import customerService from "../service.js";
import GlobalFunction from "@/mixins/GlobalFunction";
import _ from "lodash";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false,
    },
    editCustomer: {
      type: Object,
    },
  },
  name: "update-customer",
  data() {
    return {
      loading: false,
      dialog: false,
      customer: {
        isActive: true,
        fatherName: null,
        fatherPhoneNumber: null,
        fatherEmailAddress: null,
        motherName: null,
        motherPhoneNumber: null,
        motherEmailAddress: null,
        emergencyContactName: null,
        emergencyContactNumber: null,
        emergencyContactEmailAddress: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        note: null,
      },
    };
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    customer: {
      fatherName: {
        required,
      },
    },
  },
  watch: {
    editDialog(val) {
      this.customer = _.clone(this.editCustomer);
      this.dialog = val;
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    fatherNameErrors() {
      const errors = [];
      if (!this.$v.customer.fatherName.$dirty) return errors;
      if (!this.$v.customer.fatherName.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.customer = {
        name: null,
        email: null,
        phoneNumber: null,
        contactName: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        note: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        if (this.customer.phoneNumber){
          this.customer.phoneNumber = this.customer.phoneNumber.replace(
            /[^a-zA-Z0-9]/g,
            ""
          );
        }
        if (this.customer.fatherPhoneNumber) {
          this.customer.fatherPhoneNumber = this.customer.fatherPhoneNumber.replace(
            /[^a-zA-Z0-9]/g,
            ""
          );
        }
        if (this.customer.motherPhoneNumber) {
          this.customer.motherPhoneNumber = this.customer.motherPhoneNumber.replace(
            /[^a-zA-Z0-9]/g,
            ""
          );
        }
        return customerService
          .update(this.customer.id, this.customer)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "customer is updated!",
                });
              this.loading = false;
              this.$emit("submit");
              this.$events.emit("customerListEvent");

              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
